import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ebb90d46"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "border"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");

  const _component_van_picker = _resolveComponent("van-picker");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_field, {
    modelValue: $setup.popup.show_name || $props.show_name,
    "is-link": "",
    label: $props.label,
    required: $props.required,
    onClick: $setup.handlerShow,
    readonly: "",
    rules: $props.rules
  }, null, 8, ["modelValue", "label", "required", "onClick", "rules"]), _createVNode(_component_van_popup, {
    show: $setup.popup.show,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $setup.popup.show = $event),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $setup.popup.data,
      title: $props.label,
      onCancel: _cache[0] || (_cache[0] = $event => $setup.popup.show = false),
      onConfirm: $setup.confirm,
      "columns-field-names": {
        text: $props.fieldText,
        value: $props.fieldValue
      }
    }, null, 8, ["columns", "title", "onConfirm", "columns-field-names"])]),
    _: 1
  }, 8, ["show"]), _hoisted_1]);
}